export const translationLivechat_en_autoClose = {
  livechatSettingsSectionAutoClose: "Inactive chats",
  livechatSettingsAutoCloseEnabled: "Close inactive chats automatically",
  livechatSettingsAutoCloseEnabledHelp: "When the visitor doesn't reply to the agent's message.",
  livechatSettingsAutoCloseWarning: "Warn the visitor after",
  livechatSettingsAutoCloseGrace: "Close the chat after the warning",
  livechatSettingsAutoCloseMinutes: "{minutes} min",
  livechatSettingsAutoCloseHour: "1 hour",
  livechatSettingsAutoCloseHours: "{hours} hours",
  livechatSettingsAutoCloseNever: "Never closes if the visitor wrote last.",
  livechatSettingsAutoCloseTextShow: "Customize warning message",
  livechatSettingsAutoCloseTextHide: "Hide warning message",
  livechatSettingsAutoCloseText: "Warning message",
  livechatSettingsAutoCloseTextPlaceholder:
    "Are you still there? This chat will close in {minutes} minutes if we don't hear from you.",
  livechatSettingsAutoCloseTextPlaceholderOne:
    "Are you still there? This chat will close in 1 minute if we don't hear from you.",
  livechatSettingsAutoCloseInvalid:
    "Warn after must be 1 to 1440 minutes and close after the warning 1 to 120 minutes.",
  livechatAutoCloseCountdown: "Closes in {time} unless the visitor replies",
  livechatAutoCloseCardBadge: "Closes in {time}",
  livechatAutoCloseKeepOpen: "Keep open",
  livechatAutoCloseKeepingOpen: "Keeping open…",
  livechatAutoCloseKeptOpen: "Auto-close is off for this chat",
  livechatAutoCloseKeepOpenFailed: "Could not keep the chat open. Try again.",
  livechatAutoClosedNotice: "Closed automatically because the visitor did not reply.",
  livechatAutoClosingNow: "Closing…",
};
